type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
};

export const SUBJECT_ADDRESS = [
  {
    key: "addressTypeId",
    label: "Type Of Address",
    columns: [{ key: "addresstypedesc", label: "" }],
  },
  {
    key: "address_details",
    label: "Address Details",
    columns: [
      { key: "addressLine1", label: "Address Line#1" },
      { key: "addressLine2", label: "Address Line#2" },
      { key: "addressLine3", label: "Address Line#3" },
      { key: "city", label: "City" },
      { key: "country", label: "Country" },
      { key: "state", label: "State" },
      { key: "zipCode", label: "Zip Code" },
    ],
  },
  {
    key: "contact_details",
    label: "Communication Details",
    columns: [
      { key: "phoneNumber", label: "Ph No" },
      { key: "emailAddress", label: "Email Address" },
      { key: "faxNumber", label: "Fax No" },
    ],
  },
  {
    key: "actions",
    label: "Action",
    columns: [{ key: "actions", label: "" }],
  },
];

export const SUBJECT_LOG_HEADERS: Header[] = [
  { key: "createdbyName", label: "Created By" },
  { key: "createddate", label: "Created On" },
  { key: "modifiedbyName", label: "Last Modified By" },
  { key: "modifieddate", label: "Last Modified On" },
];

export const INJURY_HEADERS: Header[] = [
  { key: "injuryTypeName", label: "Injury Type ", style: { width: "13%" } },
  { key: "formattedDate", label: "Date of Incident" },
  { key: "insuranceCarrierName", label: "Insurance Carrier" },
  { key: "doctorName", label: "QME Doctor" },
  { key: "claimNumber", label: "Claim  No" },
  {
    key: "isPrimaryInjury",
    label: "Primary for billing?",
    style: { width: "10%" },
  },
  // { key: "natureOfInjuryName", label: "Nature of injury" },
  // {
  //   key: "severityOfInjuryName",
  //   label: "Severity of injury",
  //   style: { width: "11%" },
  // },
  //{ key: "injuryDetails", label: "Injury details " },
  { key: "bodyPartsAffected", label: "Body Parts Affected" },

  // { key: "additionalComments", label: "Additional comments" },

  {
    key: "actions",
    label: "Action",
    //sortable: true,
    style: { width: "7%" },
  },
];
export const INJURY_LOG_HEADERS: Header[] = [
  { key: "createdByName", label: "Created By" },
  { key: "createdDate", label: "Created On" },
  { key: "modifiedByName", label: "Last Modified By" },
  { key: "modifiedDate", label: "Last Modified On" },
];
